import VerifyCardsForm from './VerifyCardsForm';

export default VerifyCardsForm;
